<div class="slider">
	<nz-slider
			nzTooltipVisible="never" [nzMarks]="markers" [nzIncluded]="false"
			[nzMax]="sliderMarks.choices.length-1" [(ngModel)]="question.selected"
	>
	</nz-slider>
</div>

